
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { ApiFormService, Validators } from '@personal-area/global/form-validation/services';
import { ErrorTexts } from '@personal-area/global/form-validation/models';
import { FormFieldComponent } from '@personal-area/global/ui'
import { TranslateModule } from '@ngx-translate/core';
import { AccountService } from '@personal-area/global/accounts/services';

import { finalize } from 'rxjs/operators';

interface DialogData {
  accountId: number;
  userId: number;
  comment: string;
}

@Component({
    selector: 'app-account-description-popup',
    templateUrl: './account-description-popup.component.html',
    styleUrls: ['./account-description-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    ReactiveFormsModule,
    MatDialogModule,
    TranslateModule,
    FormFieldComponent
]
})
export class AccountDescriptionPopupComponent implements OnInit {

  public form: UntypedFormGroup;
  public error: string;
  public maxLength = 255;

  public submitErrors: EventEmitter<void>;

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: DialogData,
    public dialogRef: MatDialogRef<AccountDescriptionPopupComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _formService: ApiFormService,
    private _accountService: AccountService,
  ) {
    this.submitErrors = new EventEmitter<void>();
  }

  public fieldErrors(field: string): ErrorTexts {
    return {
      required: `account-popup.error.${field}-required`,
      maxlength: `account-popup.error.${field}-invalid`,
    };
  }

  ngOnInit() {
    this.form = this._formBuilder.group({
      comment: [this._data.comment || '', [
        Validators.required,
        Validators.maxLength(this.maxLength),
      ]],
    });
  }

  formSubmit() {
    if (this.form.valid) {
      const comment = this.form.value.comment.replace(/^\s+/g, '').trim();
      this.form.disable();
      this._accountService.changeComment(this._data.userId, this._data.accountId, comment).pipe(
        finalize(() => this.form.enable()),
      ).subscribe(() => {
        this.dialogRef.close(comment);
      }, err => {
        this._formService.defaultFormError(err, this.form);
        this.submitErrors.next();
      });
    } else {
      this.submitErrors.next();
    }
  }
}
